import { render } from "./ClassDetailsTitle.vue?vue&type=template&id=3ab81d1e&scoped=true&ts=true"
import script from "./ClassDetailsTitle.vue?vue&type=script&lang=ts"
export * from "./ClassDetailsTitle.vue?vue&type=script&lang=ts"

import "./ClassDetailsTitle.vue?vue&type=style&index=0&id=3ab81d1e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab81d1e"]])

export default __exports__